import { ASSET_KEYS, FILE_TYPE } from "./constants";
import { isDocumentLikeFileType } from "./fileTypes";
export const assetConstructor = item => {
  const filetype = item.file_properties.format_type;
  const asset = {
    [ASSET_KEYS.external_id]: item.external_id,
    [ASSET_KEYS.filename]: item.filename,
    [ASSET_KEYS.id]: item.id,
    [ASSET_KEYS.display_name]: item.metadata?.fields?.displayName[0],
    [ASSET_KEYS.altText]: item.metadata?.fields?.altText[0]
  };
  if (filetype === FILE_TYPE.video) {
    asset.embed_code = item.embeds.video_player.html;
    asset.embed_link = item.embeds.video_player.url;
    asset.thumbnail_link = item.embeds.video_poster.url;
  }
  if (filetype === FILE_TYPE.audio) {
    asset.embed_code = item.embeds.streaming_mp3.html;
    asset.embed_link = item.embeds.streaming_mp3.url;
  }
  if (filetype === FILE_TYPE.image) {
    asset.embed_code = item.embeds.OriginalImagewithDownload.html;
    asset.embed_link = item.embeds.OriginalImagewithDownload.url;
  }
  if (isDocumentLikeFileType(filetype)) {
    asset.embed_code = item.embeds?.document_html5_viewer?.html || item.embeds?.original?.html || '';
    asset.embed_link = item.embeds?.document_html5_viewer?.url || item.embeds?.original?.url;
    asset.thumbnail_link = item.embeds?.document_thumbnail?.url;
    asset.download_link = item.embeds?.original?.url;
    asset.allowDownload = false;
  }
  asset.instructorOnly = item?.instructorOnly ?? false;
  return asset;
};